import PropTypes from 'prop-types'
import React from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import queryString from 'query-string'

// Redux
import { onboardUser } from 'app/state/modules/hacker'


const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired, // withRouter
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired, // withRouter
  isAuthenticated: PropTypes.bool.isRequired,
  onboardUser: PropTypes.func.isRequired,
}

class Invite extends React.Component {
  componentDidMount() {
    let inviteToken = queryString.parse(this.props.location.search).h || null
    if (inviteToken === null) {
      inviteToken = this.props.match.params.id || null
    }
    if (inviteToken) {
      // setting invite token...
      window.localStorage.setItem('hackedu.teams.invite_token', inviteToken)

      if (!this.props.isAuthenticated) {
          // edirecting to register page...
        this.props.history.push('/register')
      } else {
        // logged in and onboarding user...
        this.props.onboardUser(this.props.idToken, inviteToken, null).then(() => {
          // use window.location.replace instead of this.props.history.push so that page refreshes
          // and token gets refreshed.
          window.location.replace('/')
        })
      }
    } else {
      // redirecting to home...
      this.props.history.push('/')
    }
  }

  render() {
    return <div />
  }
}

Invite.propTypes = propTypes


const mapStateToProps = state => ({
  isAuthenticated: state.auth.authenticationStatus === 'LOGGED_IN',
  idToken: state.auth.user.idToken,
})

const mapDispatchToProps = dispatch => ({
  onboardUser: (idToken, onboardingToken) => dispatch(onboardUser(idToken, onboardingToken)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Invite))
